import React, {
  createContext,
  useContext,
  useState,
  useCallback,
  useEffect,
} from 'react';
import { getFeatureFlag } from '../pages/settings/FeatureFlagsSetting/services';
import PropTypes from 'prop-types';

const SettingsContext = createContext();

export const SettingsProvider = ({ children }) => {
  const [loading, setLoading] = useState(false);
  const [settings, setSettings] = useState({
    flags: {},
  });
  //#region Flags Assignment
  const flags = useCallback(async () => {
    try {
      setLoading(true);
      const r = await getFeatureFlag();
      let flags = {};
      (r || []).forEach((flag) => {
        flags[flag.key] = flag.value;
      });
      updateSetting('flags', flags);
    } catch (error) {
      console.error('Error fetching feature flags:', error);
    } finally {
      setLoading(false);
    }
  }, []);

  const updateSetting = (key, value) => {
    setSettings((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  const resetSettings = useCallback(() => {
    setSettings({
      flags: {},
    });
  }, []);

  const value = {
    loading,
    settings,
    refetchFlags: flags,
    updateSetting,
    resetSettings,
  };

  useEffect(() => {
    flags();
  }, [flags]);

  return <SettingsContext.Provider value={value}>{children}</SettingsContext.Provider>;
};
/**
 * @returns \{
    loading: boolean,
    settings: object,
    refetchFlags: function,
    updateSetting: function,
    resetSettings: function,
  }
 */
export const useSettings = () => {
  const context = useContext(SettingsContext);
  if (!context) {
    throw new Error('useSettings must be used within SettingsProvider');
  }
  return context;
};

SettingsProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
